(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-why-it-matters"] && !Shopify.designMode) return;
  try {
    
  class WhyItMatters extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('.why-matters-tab'));
      this.panels = Array.from(this.querySelectorAll('.why-matters-panel'));
      this.images = Array.from(this.querySelectorAll('.why-matters-image-wrap'));
      this.pod = this.querySelector('.why-matters-pod');
      this.pill = this.querySelector('.why-matters-pill');
    }

    connectedCallback() {
      if (!this.tabs.length) return;
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(parseInt(tab.dataset.index, 10)));
        tab.addEventListener('keydown', (e) => this.onKey(e));
      });
      const start = parseInt(this.dataset.defaultIndex || '0', 10);
      this.activate(start, true);
      this.ro = new ResizeObserver(() => this.movePod(this.activeIndex));
      this.ro.observe(this.pill);
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    activate(index, instant) {
      if (index < 0 || index >= this.tabs.length) return;
      this.activeIndex = index;

      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      this.images.forEach((img, i) => {
        img.classList.toggle('is-active', i === index);
      });

      if (instant) {
        const prev = this.pod.style.transition;
        this.pod.style.transition = 'none';
        this.movePod(index);
        // force reflow then restore
        void this.pod.offsetWidth;
        this.pod.style.transition = prev;
      } else {
        this.movePod(index);
      }
    }

    movePod(index) {
      const tab = this.tabs[index];
      if (!tab || !this.pod || !this.pill) return;
      const tabRect = tab.getBoundingClientRect();
      const pillRect = this.pill.getBoundingClientRect();
      const inset = 4; // horizontal breathing room around the pod within the tab
      const x = (tabRect.left - pillRect.left) + inset;
      const w = Math.max(0, tabRect.width - inset * 2);
      this.pod.style.width = `${w}px`;
      this.pod.style.transform = `translateX(${x}px)`;
    }

    onKey(e) {
      const isLTR = getComputedStyle(this).direction !== 'rtl';
      const next = isLTR ? 'ArrowRight' : 'ArrowLeft';
      const prev = isLTR ? 'ArrowLeft' : 'ArrowRight';
      if (e.key !== next && e.key !== prev && e.key !== 'Home' && e.key !== 'End') return;
      e.preventDefault();
      let i = this.activeIndex;
      if (e.key === next) i = (i + 1) % this.tabs.length;
      else if (e.key === prev) i = (i - 1 + this.tabs.length) % this.tabs.length;
      else if (e.key === 'Home') i = 0;
      else if (e.key === 'End') i = this.tabs.length - 1;
      this.activate(i);
      this.tabs[i].focus();
    }
  }

  if (!customElements.get('why-it-matters')) {
    customElements.define('why-it-matters', WhyItMatters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-header"] && !Shopify.designMode) return;
  try {
    
  class DmHeader extends HTMLElement {
    connectedCallback() {
      this.sticky = this.dataset.sticky === 'true';
      this.lastScroll = window.scrollY || 0;
      this.ticking = false;

      // dockOffset = combined height of everything above the header in the
      // header group (ticker, announcement bar). Used as the threshold before
      // hide/reveal kicks in.
      this.measureOffset();
      this.onResize = () => { this.measureOffset(); this.update(); };
      window.addEventListener('resize', this.onResize, { passive: true });
      // Re-measure once everything (fonts, announcement bar images) has loaded.
      window.addEventListener('load', this.onResize, { once: true });

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.update();
    }

    measureOffset() {
      // Sum the layout height of the preceding header-group sections — this is
      // scroll-independent.
      let h = 0;
      let sib = this.parentElement && this.parentElement.previousElementSibling;
      while (sib) {
        h += sib.offsetHeight || 0;
        sib = sib.previousElementSibling;
      }
      this.dockOffset = h;
    }

    liveTop() {
      // The live bottom edge of whatever sits above the header right now. This
      // tracks both a normal announcement bar (scrolls away → bottom goes to 0)
      // and a sticky one (stays pinned → header stays docked below it), so the
      // pills never overlap the announcement bar in either case.
      let bottom = 0;
      let sib = this.parentElement && this.parentElement.previousElementSibling;
      while (sib) {
        if (sib.getBoundingClientRect) {
          const b = sib.getBoundingClientRect().bottom;
          if (b > bottom) bottom = b;
        }
        sib = sib.previousElementSibling;
      }
      return Math.max(0, bottom);
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const dock = this.dockOffset || 0;

      // Dock the header right below whatever is above it (announcement bar etc.).
      const top = Math.round(this.liveTop());
      this.style.top = top + 'px';
      // The drawer is anchored to this element, so it needs the same offset to
      // work out its height (see .dm-header .menu-drawer).
      this.style.setProperty('--dm-header-top', top + 'px');

      // No hide/reveal while still within the announcement-bar region,
      // or when sticky behaviour is disabled.
      if (!this.sticky || y <= dock + 4) {
        this.classList.remove('dm-header--hidden');
        this.lastScroll = y;
        return;
      }

      if (y > this.lastScroll + 4) {
        // Scrolling down → hide and close the drawer if it is open.
        this.classList.add('dm-header--hidden');
        this.closeDrawer();
      } else if (y < this.lastScroll - 4) {
        // Scrolling up → reveal.
        this.classList.remove('dm-header--hidden');
      }

      this.lastScroll = y;
    }

    closeDrawer() {
      const details = this.querySelector('header-drawer details[open]');
      if (details) details.removeAttribute('open');
    }
  }

  if (!customElements.get('dm-header')) {
    customElements.define('dm-header', DmHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
